// extracted by mini-css-extract-plugin
export default {"form":"Form_form__to5Xx","center":"Form_center__jbjce","form-w-75":"Form_form-w-75__XrZ7S"};